import { render, staticRenderFns } from "./datos-solicitud.vue?vue&type=template&id=fc30de3a&"
import script from "./datos-solicitud.component.ts?vue&type=script&lang=ts&"
export * from "./datos-solicitud.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports